import { FIELD_KEYS } from 'app/developer-v3/constants';

import type { LegacyTriggerOperationType } from 'app/developer-v3/platformSchema/legacy';
import type { StringMap } from 'app/common/types';

export type TypeHookValue = LegacyTriggerOperationType;

const DATA_SOURCE_CHOICES: Array<StringMap> = [
  { value: 'polling', label: 'Polling' },
  { value: 'static', label: 'Static Webhooks' },
  { value: 'rest', label: 'Rest Hooks' },
  { value: 'notification', label: 'Notification REST Hooks' },
].map(({ value, label }) => ({ value, label, key: value }));

const dataSourceField = {
  label: 'Data Source',
  type: 'single-line-string',
  required: true,
  readOnly: true,
  choices: DATA_SOURCE_CHOICES,
  hasSearch: false,
  helpText:
    'Choose how Zapier will receive data from your API. Use <strong>Webhooks</strong> or <strong>Rest Hooks</strong> to send new or updated data to Zapier automatically, or <strong>Polling</strong> to have Zapier check the API for new items periodically.',
};

const pollingDataSourceField = { ...dataSourceField, key: FIELD_KEYS.type };
const hookDataSourceField = { ...dataSourceField, key: FIELD_KEYS.hookType };

const urlField = {
  label: 'Polling: URL',
  key: FIELD_KEYS.url,
  type: 'single-line-string',
  required: false,
  helpText:
    'Enter the URL Zapier will poll for new items with a GET call. Response must return a reverse-chronologically ordered array. Customize API request and call in the Advanced Legacy Web Builder settings.',
};

const outputFieldsUrlField = {
  label: 'Custom Trigger Result Fields URL',
  key: FIELD_KEYS.outputFieldsUrl,
  type: 'single-line-string',
  required: false,
  helpText:
    'Enter a URL where Zapier can fetch custom field names for this trigger.',
};

const eventField = {
  label: 'Webhook Event Name',
  key: FIELD_KEYS.event,
  type: 'single-line-string',
  required: false,
  helpText:
    'Enter the key or handle your webhook uses to identify the data this trigger should use.',
};

const formFields = {
  polling: [pollingDataSourceField, urlField, outputFieldsUrlField],
  static: [hookDataSourceField, urlField, outputFieldsUrlField, eventField],
  rest: [hookDataSourceField, urlField, outputFieldsUrlField, eventField],
  notification: [
    hookDataSourceField,
    urlField,
    outputFieldsUrlField,
    eventField,
  ],
};

export default formFields;
